import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './EntityImport.frontend.types'

@Injectable({ providedIn: 'root' })
export class EntityImport_entity_import_parse_errorsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { request_id?: string }): Promise<{ project?: string, warehouse?: string, reference?: string, summary?: string, request?: string, messages?: any[] }> 
  {
    let url = `${environment.backendUrl}api/EntityImport/functions/entity_import_parse_errors`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

